import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Self } from "@angular/core";
import { ControlValueAccessor, FormControl, FormGroupDirective, NgControl, NgForm, ValidationErrors } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";
import { Subject } from "rxjs";
import { takeUntil } from 'rxjs/operators';
import { CompanyInfo } from "src/app/models/companyinfo.model";
import { SpinnerService } from "src/app/services/spinner.service";
import { SnackbarMessageComponent } from "../snackbar/snackbar-message/snackbar-message.component";
import { MatSnackBar } from "@angular/material/snack-bar";


/** Error when invalid control is dirty or touched*/
export class CustomErrorStateMatcher implements ErrorStateMatcher {

  private _formControl!: FormControl;
  constructor(private formControl: FormControl) {
    
    this._formControl = formControl; //form?.control.controls.youForm as FormGroup;

  }

  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    if (this._formControl) {
      return !!(this._formControl && this._formControl.invalid && (this._formControl.dirty || this._formControl.touched || (form && form.submitted)));
    }
    return false;
  }
}



@Component({
  selector: 'app-orgnum-form-control',
  templateUrl: './orgnum-form-control.component.html',
  styleUrls: ['./orgnum-form-control.component.scss'],
  host: { '(blur)': 'onTouched($event)' },
  providers: [
    // {
    //   provide: MatFormFieldControl,
    //   useExisting: OrgnumFormControlComponent
    // },
    // {
    //   provide: NG_VALUE_ACCESSOR,
    //   useExisting: forwardRef(() => OrgnumFormControlComponent),
    //   multi: true
    // },
    // {
    //   provide: NG_VALUE_ACCESSOR,
    //   multi: true,
    //   useExisting: OrgnumFormControlComponent
    // },
    // {
    //   provide: NG_VALIDATORS,
    //   multi: true,
    //   useExisting: OrgnumFormControlComponent
    // }

  ]
})
export class OrgnumFormControlComponent implements OnInit, OnDestroy, ControlValueAccessor {

  @Output() companyInfoReceived = new EventEmitter<CompanyInfo | null>();
  @Input() companyInfo: CompanyInfo | null = null;

  private componentDestroyed = new Subject();
  private _orgNumber: string | null = null;


  disabled = false;

  matErrorMatcher!:CustomErrorStateMatcher; // = new CustomErrorStateMatcher();

  // Function to call when the rating changes.
  //private onChange!: Function;
  onChange = (orgNumber: string | null) => {

  };

  // Function to call when the input is touched (when a star is clicked).
  //private onTouched!: Function;
  onTouched = (event: any) => { };

  get value(): string | null {
    return this._orgNumber;
  }

  set value(value: string | null) {
    this._orgNumber = value;
    this.onChange(value);
  }

  get errors(): ValidationErrors | null {
    if (this.controlDir && this.controlDir.control) {
      return this.controlDir.control.errors;
    }
    return null;
  }


  constructor(
    private spinnerService: SpinnerService,
    private http: HttpClient,
    private snackbar: MatSnackBar,
    @Self() public controlDir: NgControl) {
    controlDir.valueAccessor = this;
  }

  ngOnInit(): void {

    if (this.controlDir.control !== null) {
      let formControl: FormControl = this.controlDir.control as FormControl;
      this.matErrorMatcher = new CustomErrorStateMatcher(formControl);
    }

    // this.caseService.BRCompanyInfo
    //   .pipe(takeUntil(this.componentDestroyed))
    //   .subscribe(
    //     (companyInfo: CompanyInfo) => {
    //       if (companyInfo !== undefined) {
    //         this.companyInfo = companyInfo;
    //         this.companyInfoReceived.emit(companyInfo);
    //       }
    //     }
    //   );

  }
  ngOnDestroy(): void {
    this.componentDestroyed.next(null);
    this.componentDestroyed.unsubscribe();
  }

  // Allows Angular to update the model (rating).
  // Update the model and changes needed for the view here.
  writeValue(value: string | null): void {
    this._orgNumber = value;
    this.onChange(this.value);
  }

  // Allows Angular to register a function to call when the model (rating) changes.
  // Save the function as a property to call later here.
  registerOnChange(fn: (orgNumber: string | null) => void): void {
    this.onChange = fn;
  }

  // Allows Angular to register a function to call when the input has been touched.
  // Save the function as a property to call later here.
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // Allows Angular to disable the input.
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  clearCompanyFormValues() {
    this.companyInfo = null;
    this.companyInfoReceived.emit(null);
  }

  getCompanyInfo(): void {

    if (this._orgNumber !== undefined && this._orgNumber !== null && this._orgNumber !== '') {
      let orgNumberRegEx = /^\d{9}$/;
      if (orgNumberRegEx.test(this._orgNumber)) {

        this.spinnerService.show('Henter info om foretaket fra enhetsregisteret');
    
        this.http.get('/api/form/search/br?query=' + this._orgNumber)
        .pipe(takeUntil(this.componentDestroyed))
          .subscribe(
            (response: any) => {
              this.companyInfo = response;
              this.companyInfoReceived.emit(this.companyInfo);
            },
            (errorResponse: HttpErrorResponse) => {
              console.log(errorResponse);
              this.spinnerService.hide();

              this.snackbar.openFromComponent(SnackbarMessageComponent, { data: {message: 'Kunne ikke finne foretak med organisasjonsnummer ' + this._orgNumber, type: 'warning'}, duration: 6000 });
            },
            () => {
              console.log('Finished loading companyinfo');
              this.spinnerService.hide();
            }
          );
     

      }
    }
  }

}